export default {"src":"/_next/static/media/spinner.f4604fa4.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};